// extracted by mini-css-extract-plugin
module.exports = {"close":"WriteToUsModal_close__1srgi","close_mobile":"WriteToUsModal_close_mobile__3NonJ","wrapper":"WriteToUsModal_wrapper__t-7yX"};